import * as React from "react";
const SvgFiRrStaff = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-staff_svg__a)">
      <path
        fill="#062147"
        d="M24 4.5C24 6.981 21.981 9 19.5 9H18a1 1 0 1 1 0-2h1.5C20.88 7 22 5.878 22 4.5S20.88 2 19.5 2h-1.436a2.51 2.51 0 0 0-2.479 2.17l-.547 4.103a7.26 7.26 0 0 1-2.055 4.157L1.707 23.707a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L11.57 11.015a5.25 5.25 0 0 0 1.486-3.007l.547-4.103A4.515 4.515 0 0 1 18.064 0H19.5C21.981 0 24 2.019 24 4.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-staff_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStaff;
